
export const tiktokVideos = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=young%20woman%20filming%20ugc%20tiktok%20video%20in%20trendy%20new%20york%20apartment%20holding%20skincare%20product%20vertical%20format%20phone%20recording%20warm%20lighting%20cozy%20aesthetic%20feminine%20pink%20tones&width=360&height=640&seq=tiktok1&orientation=portrait',
    caption: 'Morning skincare routine that changed my life',
    likes: '245K',
    comments: '3.2K',
    views: '1.8M'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=stylish%20woman%20doing%20outfit%20transition%20tiktok%20video%20in%20modern%20bedroom%20mirror%20full%20body%20fashion%20content%20vertical%20format%20trendy%20clothing%20warm%20soft%20lighting%20feminine%20aesthetic&width=360&height=640&seq=tiktok2&orientation=portrait',
    caption: 'GRWM for NYFW after party',
    likes: '189K',
    comments: '2.1K',
    views: '1.2M'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=female%20content%20creator%20unboxing%20beauty%20products%20on%20camera%20vertical%20tiktok%20format%20excited%20expression%20modern%20desk%20setup%20ring%20light%20warm%20tones%20aesthetic%20packaging%20feminine%20style&width=360&height=640&seq=tiktok3&orientation=portrait',
    caption: 'Unboxing the new Glossier drop',
    likes: '312K',
    comments: '4.5K',
    views: '2.3M'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=young%20woman%20walking%20through%20new%20york%20city%20streets%20filming%20herself%20vertical%20tiktok%20format%20golden%20hour%20sunset%20light%20urban%20fashion%20street%20style%20content%20creation%20warm%20cinematic%20tones&width=360&height=640&seq=tiktok4&orientation=portrait',
    caption: 'NYC golden hour walk with me',
    likes: '156K',
    comments: '1.8K',
    views: '980K'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=woman%20doing%20makeup%20tutorial%20tiktok%20video%20close%20up%20vanity%20mirror%20beauty%20products%20vertical%20format%20professional%20lighting%20glam%20look%20step%20by%20step%20warm%20feminine%20aesthetic&width=360&height=640&seq=tiktok5&orientation=portrait',
    caption: 'Clean girl makeup in 5 mins',
    likes: '278K',
    comments: '3.8K',
    views: '1.5M'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=female%20influencer%20trying%20on%20haul%20of%20clothing%20items%20in%20bright%20bedroom%20vertical%20tiktok%20format%20fashion%20try%20on%20trendy%20pieces%20modern%20aesthetic%20warm%20soft%20lighting%20feminine%20style&width=360&height=640&seq=tiktok6&orientation=portrait',
    caption: 'Zara haul that broke my wallet',
    likes: '201K',
    comments: '2.7K',
    views: '1.1M'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=woman%20cooking%20aesthetic%20recipe%20in%20modern%20kitchen%20vertical%20tiktok%20format%20food%20content%20creation%20beautiful%20plating%20warm%20lighting%20cozy%20home%20cooking%20feminine%20aesthetic&width=360&height=640&seq=tiktok7&orientation=portrait',
    caption: 'Viral pasta recipe you need to try',
    likes: '167K',
    comments: '2.3K',
    views: '890K'
  }
];

export const instagramPosts = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20lifestyle%20flatlay%20with%20coffee%20cup%20notebook%20fresh%20flowers%20on%20marble%20table%20morning%20light%20aesthetic%20feminine%20pink%20and%20white%20tones%20professional%20instagram%20photography&width=600&height=600&seq=ig1&orientation=squarish',
    caption: 'Morning rituals',
    likes: '24.5K',
    comments: '892'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=new%20york%20city%20rooftop%20view%20manhattan%20skyline%20sunset%20golden%20hour%20warm%20tones%20urban%20landscape%20modern%20buildings%20professional%20cityscape%20photography%20feminine%20aesthetic&width=600&height=600&seq=ig2&orientation=squarish',
    caption: 'NYC golden hour',
    likes: '31.2K',
    comments: '1.2K'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=luxury%20skincare%20products%20arranged%20beautifully%20on%20pink%20velvet%20surface%20aesthetic%20flatlay%20soft%20natural%20lighting%20beauty%20brand%20content%20professional%20product%20photography%20feminine%20tones&width=600&height=600&seq=ig3&orientation=squarish',
    caption: 'Current favorites',
    likes: '28.7K',
    comments: '654'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=stylish%20brunch%20table%20setting%20at%20trendy%20new%20york%20restaurant%20avocado%20toast%20fresh%20juice%20beautiful%20plating%20natural%20light%20food%20photography%20aesthetic%20feminine%20warm%20tones&width=600&height=600&seq=ig4&orientation=squarish',
    caption: 'NYC brunch spots',
    likes: '19.8K',
    comments: '423'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=cozy%20reading%20nook%20with%20books%20candles%20and%20blanket%20warm%20ambient%20lighting%20lifestyle%20photography%20inviting%20atmosphere%20feminine%20aesthetic%20soft%20pink%20neutral%20tones&width=600&height=600&seq=ig5&orientation=squarish',
    caption: 'Sunday slow mornings',
    likes: '22.3K',
    comments: '567'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=trendy%20outfit%20details%20close%20up%20designer%20handbag%20and%20accessories%20on%20neutral%20background%20fashion%20content%20creation%20professional%20photography%20warm%20soft%20lighting%20feminine%20aesthetic&width=600&height=600&seq=ig6&orientation=squarish',
    caption: 'Details matter',
    likes: '26.1K',
    comments: '789'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20flower%20arrangement%20peonies%20and%20roses%20in%20glass%20vase%20on%20white%20table%20natural%20window%20light%20aesthetic%20still%20life%20photography%20feminine%20pink%20blush%20tones%20professional&width=600&height=600&seq=ig7&orientation=squarish',
    caption: 'Fresh blooms',
    likes: '18.9K',
    comments: '345'
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=aesthetic%20workspace%20desk%20setup%20with%20macbook%20fresh%20flowers%20stationery%20and%20coffee%20modern%20feminine%20home%20office%20natural%20lighting%20clean%20organized%20professional%20lifestyle%20photography&width=600&height=600&seq=ig8&orientation=squarish',
    caption: 'Where the magic happens',
    likes: '21.4K',
    comments: '612'
  }
];
